import React from 'react';
import { Checkbox, TextField, Typography, Collapse, withStyles } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import CloseImage from '../../assets/ic_close.png';
import DateFnsUtils from '@date-io/date-fns';
import { DatePicker, KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import ImageUploader from 'react-images-upload';
import ColorPicker from 'material-ui-color-picker'
import editProf from '../../assets/editProf.png';
import api from '../api';


const CustomCheckbox = withStyles({
    root: {
        color: '#2a9c6c',
        '&$checked': {
            color: '#2a9c6c',
        },
        padding: 5
    },
    checked: {},
})((props) => <Checkbox color="default" {...props} />);

export default function AddPromo(props) {
    const [selectedDate, setSelectedDate] = React.useState(new Date);
    const [uploadVisible, setUploadVisible] = React.useState(false)
    const [uploadVisible2, setUploadVisible2] = React.useState(false)
    const [name, setName] = React.useState("")
    const [content, setContent] = React.useState("")
    const [subTitle, setSubTitle] = React.useState("")
    const [link, setLink] = React.useState("")
    const [warna, setWarna] = React.useState("example")
    const [background, setBackground] = React.useState([])
    const [icon, setIcon] = React.useState([])
    
    const handleDateChange = (date) => {
        setSelectedDate(date);
    };

    const onDrop = (pictureFiles, pictureDataURLs) => {
        console.log(pictureDataURLs, '----------------');
        setBackground(pictureFiles)
    }
    
    const onDrop2 = (pictureFiles, pictureDataURLs) => {
        console.log(pictureDataURLs, '----------------');
        setIcon(pictureFiles)
    }

    const uploadFoto = () => {
        console.log(background[0].name, '================1');

        setUploadVisible(false)
    }
    
    const uploadFoto2 = () => {
        console.log(background[0].name, '================2');

        setUploadVisible2(false)
    }
    const handleWarna = (color) => {
        console.log(color);
        setWarna(color)
    }

    const doSubmit = () => {
        let year = selectedDate.getFullYear()
        let month = selectedDate.getMonth() + 1
        let date = selectedDate.getDate()
        let expired = `${year}-${month}-${date}`
        let formData = new FormData()
        formData.append('hospital_id', 1)
        formData.append('background_file', background[0])
        formData.append('icon_file', icon[0])
        formData.append('title', name)
        formData.append('subtitle', subTitle)
        formData.append('content', content)
        formData.append('text_color', warna)
        formData.append('url', link)
        formData.append('expired_date', expired)
        api.create().createPromo(formData).then(response => {
            console.log(response);
            props.onClose()
        })
    }

    return (
        <div className="App app-popup-show">
            <div className="popup-content-middle background-white" style={{ borderRadius: 8 }}>
                <div className="popup-panel grid grid-2x main-color" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                    <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                        <div className="popup-title">
                            <span style={{ color: 'black', fontSize: 18, }}>Tambah Promo Baru</span>
                        </div>
                    </div>
                    <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                        <button
                            type="button"
                            className="btn btn-circle btn-white"
                            onClick={() => props.onClose()}
                        >
                            <img src={CloseImage} style={{ width: 20, height: 20 }} />
                        </button>
                    </div>
                </div>

                <div className="grid grid-2x grid-mobile-none gap-15px" style={{ padding: 20 }}>
                    <div className="column-1" style={{marginTop: -10}}>
                        <div className="">
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                    margin="normal"
                                    id="validTill"
                                    label="Berlaku Hingga"
                                    format="MM/dd/yyyy"
                                    value={selectedDate}
                                    onChange={handleDateChange}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                                    style={{ width: '100%' }}
                                />
                            </MuiPickersUtilsProvider>
                        </div>
                        
                        <div>
                            <TextField
                                style={{ width: '100%', marginTop: -3 }}
                                id="content"
                                name="content"
                                label="Konten"
                                value={content}
                                // error={errorRoleName}
                                // helperText={msgErrorRN}
                                onChange={(e) => setContent(e.target.value)}
                                inputProps={{
                                    style: {
                                        fontSize: 14,
                                        fontFamily: 'Nunito Sans, sans-serif',
                                    }
                                }}
                                InputLabelProps={{
                                    style: {
                                        fontSize: 14,
                                        fontFamily: 'Nunito Sans, sans-serif',
                                        color: '#7e8085',
                                    }
                                }}
                            // defaultValue="Default Value"
                            // helperText="Some important text"
                            />
                        </div>
                        <div className="margin-bottom-20px">
                            <TextField
                                style={{ width: '100%', marginTop: 19 }}
                                id="url"
                                name="url"
                                label="Link Promo"
                                defaultChecked="aa"
                                onChange={(e) => setLink(e.target.value)}
                                value={link}
                                // error={errorRoleName}
                                // helperText={msgErrorRN}
                                // onChange={(e) => handleChange(e, '')}
                                inputProps={{
                                    style: {
                                        fontSize: 14,
                                        fontFamily: 'Nunito Sans, sans-serif',
                                        placeholder:"http://www.example.com"
                                    }
                                }}
                                InputLabelProps={{
                                    style: {
                                        fontSize: 14,
                                        fontFamily: 'Nunito Sans, sans-serif',
                                        color: '#7e8085',
                                    }
                                }}
                            // defaultValue="Default Value"
                            // helperText="Some important text"
                            />
                        </div>
                        {
                            background.length >= 1 ?
                                <div className="margin-bottom-20px">
                                    <TextField
                                        style={{ width: '100%', marginTop: 6 }}
                                        id="background"
                                        name="background"
                                        label="Gambar Latar Belakang"
                                        defaultValue="choose file..."
                                        value={background[0].name}
                                        // error={errorRoleName}
                                        // helperText={msgErrorRN}
                                        onClick={() => setUploadVisible(true)}
                                        inputProps={{
                                            style: {
                                                fontSize: 14,
                                                cursor: 'pointer',
                                                fontFamily: 'Nunito Sans, sans-serif',
                                            }
                                        }}
                                        InputLabelProps={{
                                            style: {
                                                fontSize: 14,
                                                fontFamily: 'Nunito Sans, sans-serif',
                                                color: '#7e8085',
                                            }
                                        }}
                                    // defaultValue="Default Value"
                                    // helperText="Some important text"
                                    />
                                </div>
                            :
                                <div className="margin-bottom-20px">
                                    <TextField
                                        style={{ width: '100%', marginTop: 6 }}
                                        id="background"
                                        name="background"
                                        label="Gambar Latar Belakang"
                                        defaultValue="choose file..."
                                        // value={background}
                                        // error={errorRoleName}
                                        // helperText={msgErrorRN}
                                        onClick={() => setUploadVisible(true)}
                                        inputProps={{
                                            style: {
                                                fontSize: 14,
                                                cursor: 'pointer',
                                                fontFamily: 'Nunito Sans, sans-serif',
                                            }
                                        }}
                                        InputLabelProps={{
                                            style: {
                                                fontSize: 14,
                                                fontFamily: 'Nunito Sans, sans-serif',
                                                color: '#7e8085',
                                            }
                                        }}
                                    // defaultValue="Default Value"
                                    // helperText="Some important text"
                                    />
                                </div>
                        }
                    </div>

                    <div className="column-2">
                        <div className="margin-bottom-20px">
                            <TextField
                                style={{ width: '100%', marginTop: 7 }}
                                id="title"
                                name="title"
                                label="Nama Promo"
                                value={name}
                                // error={errorRoleName}
                                // helperText={msgErrorRN}
                                onChange={(e) => setName(e.target.value)}
                                inputProps={{
                                    style: {
                                        fontSize: 14,
                                        fontFamily: 'Nunito Sans, sans-serif',
                                    }
                                }}
                                InputLabelProps={{
                                    style: {
                                        fontSize: 14,
                                        fontFamily: 'Nunito Sans, sans-serif',
                                        color: '#7e8085',
                                    }
                                }}
                            // defaultValue="Default Value"
                            // helperText="Some important text"
                            />
                        </div>
                        <div className="margin-bottom-20px">
                            <TextField
                                style={{ width: '100%', marginTop: 7 }}
                                id="subtitle"
                                name="subtitle"
                                label="Keterangan Promo"
                                value={subTitle}
                                // error={errorRoleName}
                                // helperText={msgErrorRN}
                                onChange={(e) => setSubTitle(e.target.value)}
                                inputProps={{
                                    style: {
                                        fontSize: 14,
                                        fontFamily: 'Nunito Sans, sans-serif',
                                    }
                                }}
                                InputLabelProps={{
                                    style: {
                                        fontSize: 14,
                                        fontFamily: 'Nunito Sans, sans-serif',
                                        color: '#7e8085',
                                    }
                                }}
                            // defaultValue="Default Value"
                            // helperText="Some important text"
                            >
                            </TextField>
                        </div>
                        
                        <div>
                            <ColorPicker
                                style={{ width: "100%", marginTop: 16 }}
                                name='color'
                                label='Warna Tulisan'
                                defaultValue={warna}
                                // value={this.state.color} - for controlled component
                                onChange={(color) => handleWarna(color)}
                                value={warna}
                            />
                        </div>
                        {
                            icon.length >= 1 ?
                                <div className="margin-bottom-20px">
                                    <TextField
                                        style={{ width: '100%', marginTop: 7, cursor: 'pointer' }}
                                        id="iconFile"
                                        name="iconFile"
                                        label="Gambar Icon"
                                        defaultValue="choose file..."
                                        value={icon[0].name}
                                        // error={errorRoleName}
                                        // helperText={msgErrorRN}
                                        // onChange={(e) => handleChange(e, '')}
                                        onClick={() => setUploadVisible2(true)}
                                        inputProps={{
                                            style: {
                                                fontSize: 14,
                                                fontFamily: 'Nunito Sans, sans-serif',
                                                cursor: 'pointer',
                                                
                                            }
                                        }}
                                        InputLabelProps={{
                                            style: {
                                                fontSize: 14,
                                                fontFamily: 'Nunito Sans, sans-serif',
                                                color: '#7e8085',
                                            }
                                        }}
                                    > 
                                    </TextField>
                                </div>
                            :
                                <div className="margin-bottom-20px">
                                    <TextField
                                        style={{ width: '100%', marginTop: 7, cursor: 'pointer' }}
                                        id="iconFile"
                                        name="iconFile"
                                        label="Gambar Icon"
                                        defaultValue="choose file..."
                                        // value={roleName}
                                        // error={errorRoleName}
                                        // helperText={msgErrorRN}
                                        // onChange={(e) => handleChange(e, '')}
                                        onClick={() => setUploadVisible2(true)}
                                        inputProps={{
                                            style: {
                                                fontSize: 14,
                                                fontFamily: 'Nunito Sans, sans-serif',
                                                cursor: 'pointer',
                                                
                                            }
                                        }}
                                        InputLabelProps={{
                                            style: {
                                                fontSize: 14,
                                                fontFamily: 'Nunito Sans, sans-serif',
                                                color: '#7e8085',
                                            }
                                        }}
                                    > 
                                    </TextField>
                                </div>
                        }
                    </div>
                </div>
                <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                    <div className="column-1" style={{ alignSelf: 'center' }}>
                    </div>
                    <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                        <div
                            onClick={() => props.onClose()}
                            style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                            <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                        </div>
                        <div
                            onClick={(e) => doSubmit(e)}
                            style={{ height: 32, width: 150, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                            <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Simpan</Typography>
                        </div>
                    </div>
                </div>
                {uploadVisible && (
                    <div className="App app-popup-show" style={{ zIndex: 5000 }}>
                        <div className="popup-content background-white border-radius" style={{ borderRadius: 8 }}>
                            <div className="popup-panel grid grid-2x main-color" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                                <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                                    <div className="popup-title">
                                        <span style={{ color: 'black', fontSize: 18 }}>Upload File</span>
                                    </div>
                                </div>
                                <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                                    <button
                                        type="button"
                                        className="btn btn-circle btn-white"
                                        onClick={() => {
                                            setUploadVisible(false)
                                            // setPicture("")
                                        }}
                                    >
                                        <img src={CloseImage} />
                                    </button>
                                </div>
                            </div>
                            <ImageUploader
                                withIcon={true}
                                withPreview
                                buttonStyles={background.length > 0 ? { display: 'none' } : null}
                                buttonText={'Select Picture'}
                                onChange={onDrop}
                                imgExtension={['.jpg', '.gif', '.png', '.gif', '.jpeg']}
                                maxFileSize={1000000}
                                label={"Max file size: 1 Mb, accepted: jpg or png"}
                            />
                            {background.length > 0 ?
                                <div style={{ display: 'grid', margin: 20 }}>
                                    <div style={{ justifySelf: 'center' }}>
                                        <span style={{ color: '#fff', padding: 20, paddingBottom: 10, paddingTop: 10, borderRadius: 15, cursor: 'pointer', backgroundColor: '#2a9c6c' }} onClick={() => uploadFoto()}>Upload</span>
                                    </div>
                                </div> : null
                            }
                        </div>
                    </div>
                )}
                {uploadVisible2 && (
                    <div className="App app-popup-show" style={{ zIndex: 5000 }}>
                        <div className="popup-content background-white border-radius" style={{ borderRadius: 8 }}>
                            <div className="popup-panel grid grid-2x main-color" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                                <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                                    <div className="popup-title">
                                        <span style={{ color: 'black', fontSize: 18 }}>Upload File</span>
                                    </div>
                                </div>
                                <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                                    <button
                                        type="button"
                                        className="btn btn-circle btn-white"
                                        onClick={() => {
                                            setUploadVisible2(false)
                                            // setPicture("")
                                        }}
                                    >
                                        <img src={CloseImage} />
                                    </button>
                                </div>
                            </div>
                            <ImageUploader
                                withIcon={true}
                                withPreview
                                buttonStyles={icon.length > 0 ? { display: 'none' } : null}
                                buttonText={'Select Picture'}
                                onChange={onDrop2}
                                imgExtension={['.jpg', '.gif', '.png', '.gif', '.jpeg']}
                                maxFileSize={1000000}
                                label={"Max file size: 1 Mb, accepted: jpg or png"}
                            />
                            {icon.length > 0 ?
                                <div style={{ display: 'grid', margin: 20 }}>
                                    <div style={{ justifySelf: 'center' }}>
                                        <span style={{ color: '#fff', padding: 20, paddingBottom: 10, paddingTop: 10, borderRadius: 15, cursor: 'pointer', backgroundColor: '#2a9c6c' }} onClick={() => uploadFoto2()}>Upload</span>
                                    </div>
                                </div> : null
                            }
                        </div>
                    </div>
                )}
            </div>
        </div >
    )
}